import { IbePriceModelCode } from '@gecko-akh/pkg-cruise-api-types/src/iris'
import { PRICE_MODEL_SORT_ORDER } from '../../general/master-data'
import { IPaxConfig } from '../catalog/interfaces'
import { useFilterStore } from '../index'

export const selectedPriceModel = (): IbePriceModelCode | null => {
  const filterStore = useFilterStore()

  const selectedPriceModels = filterStore.filterFields.priceModels.value
  const sortedSelectedPriceModels: IbePriceModelCode[] = []

  if (!selectedPriceModels?.length) return null

  for (const priceModel of PRICE_MODEL_SORT_ORDER) {
    if (!!selectedPriceModels.includes(priceModel)) {
      sortedSelectedPriceModels.push(priceModel)
    }
  }

  return sortedSelectedPriceModels[0]
}

export const paxConfig = () => {
  const filterStore = useFilterStore()

  const adults = filterStore.filterFields.adults
  const juveniles = filterStore.filterFields.juveniles
  const children = filterStore.filterFields.children
  const babies = filterStore.filterFields.babies

  const pax: IPaxConfig = {
    adults: !!adults.value ? parseInt(adults.value, 10) : 0,
    juveniles: !!juveniles.value ? parseInt(juveniles.value, 10) : 0,
    children: !!children.value ? parseInt(children.value, 10) : 0,
    babies: !!babies.value ? parseInt(babies.value, 10) : 0,
    key: '',
    total: 0,
  }
  pax.key = `${pax.adults}${pax.juveniles}${pax.children}${pax.babies}`
  pax.total = pax.adults + pax.juveniles + pax.children + pax.babies

  return pax
}

export const showHolidayFilterError = (): boolean => {
  const filterStore = useFilterStore()

  const holidaysByCountries = Object.values(filterStore.holidaysByCountry)
  const hasSelectedHolidayFilter = holidaysByCountries.some(holidayByCountry => holidayByCountry.selected || Object.values(holidayByCountry.federalStates).some(holidayByState => holidayByState.selected))

  return hasSelectedHolidayFilter && filterStore.holidayError
}

export default {
  selectedPriceModel,
  paxConfig,
  showHolidayFilterError
}
